import { useContext, useEffect } from 'react'
import { CadExToolbox } from './ToolboxFeatures/CadExToolbox'
import { CadExContext } from './context/CadExContext'

export const CadExCanvas = () => {
  const { useSceneElements } = useContext(CadExContext)

  const { load } = useSceneElements()
  // eslint-disable-next-line
  useEffect(() => load(), [])

  return <CadExToolbox />
}
